import dayjs from 'dayjs';
import { MONTHS_VALUES } from '@/Module/Workspace/Constants';
import type { TMonthFront } from '@/Module/Workspace/Model/Type';
interface IProps {
  persianDate: string;
}
export const preparePersianTime = ({
  persianDate
}: IProps) => {
  const date = dayjs(persianDate);
  return {
    clock: date.format('HH:mm'),
    day: date.format('D'),
    month: MONTHS_VALUES[Number(date.format('M')) - 1 as TMonthFront],
    year: date.format('YYYY'),
    wrap: date.format('A') === 'PM' ? 'ب.ظ' : 'ق.ظ'
  };
};